<template>
  <div class="battle-container" :class="[zsTjTheme]">
    <div class="round">
      <Round
        :value="currentIndex"
        :roundInfos="roundInfos"
        @change="handleChangeIndex"
        @editTeam="handleEditTeam"
        :isEdit="isEdit"
      />
    </div>
    <template v-if="hasCurrentBattleData">
      <draggable
        v-model="roundInfos[currentIndex].battleData"
        :disabled="!isEdit"
        :handle="'.drag-item'"
        :forceFallback="true"
        :move="handleOurMove"
        @start="handleOurStart"
        @end="handleOurEnd"
        :class="['drag-list']"
      >
        <div
          v-for="(item, index) in roundInfos[currentIndex].battleData"
          :key="index"
          :class="['drag-bg', item.type === 0 ? 'no-card' : 'choosed-item', destIndex === index ? 'chosen-item' : '']"
        >
          <div class="drag-item" @click="handleEditRole(item, index)">
            <img v-if="item.type === 0" class="border-line" src="@/assets/zs_imgs/battle/battle-normal.png" alt="" />
            <template v-if="item.type !== 0">
              <div v-if="item.type === 'role'" :class="['role-bg', getItemBg(item)]">
                <img class="role-img" :src="item.cover_url" alt="" />
                <div class="item-infos">
                  <div v-if="item.index" class="index">{{ item.index }}</div>
                  <div v-if="item.type === 'role'" class="corner-icon">
                    <img :src="getCornerUrl(item)" alt="" />
                  </div>
                  <div
                    v-if="
                      item.currentStrengthen &&
                        item.currentStrengthen.name &&
                        strengthArr.includes(item.currentStrengthen.name)
                    "
                    class="strenth-icon"
                  >
                    <img :src="getStrenthUrl(item.currentStrengthen.name)" alt="" />
                  </div>
                  <div class="skill-icon">
                    <template v-if="item.type === 'role'">
                      <img
                        v-if="
                          item.actionType === 'skills' &&
                            (item.currentPotentialImage || (item.currentStrengthen && item.currentStrengthen.image))
                        "
                        :src="item.currentPotentialImage || item.currentStrengthen.image"
                        alt=""
                      />
                      <img
                        v-if="item.actionType === 'damage' && item.currentSkin && item.damage_type"
                        :src="item.damage_type"
                        alt=""
                      />
                      <img
                        v-if="item.actionType === 'repel' && item.currentSkin && item.currentSkin.repel"
                        :src="item.currentSkin.repel"
                        alt=""
                      />
                      <img v-if="item.actionType === 'dead'" src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
                    </template>
                    <template v-else>
                      <img v-if="item.actionType === 'skills' && item.skill_image" :src="item.skill_image" alt="" />
                      <img v-if="item.actionType === 'damage' && item.damage_type" :src="item.damage_type" alt="" />
                      <img v-if="item.actionType === 'repel' && item.repel" :src="item.repel" alt="" />
                      <img v-if="item.actionType === 'dead'" src="@/assets/zs_imgs/battle/battle_dead.webp" alt="" />
                    </template>
                  </div>
                  <div class="bottom-info">
                    <span v-if="item.type === 'role'" class="label">
                      {{
                        item.actionType === "skills"
                          ? item.currentSkin
                            ? item.currentSkin.name
                            : item.name
                          : actionObj[item.actionType]
                      }}
                    </span>
                    <span v-else class="label">
                      {{
                        item.actionType === "skills"
                          ? item.skill_name
                            ? item.skill_name
                            : item.name
                          : actionObj[item.actionType]
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <img v-else class="role-img" :src="item.cover_url" alt="" />
            </template>
            <template v-else>
              <img
                v-if="zsTjTheme == 'light'"
                class="default-icon"
                src="@/assets/zs_imgs/battle/light-our-team-icon.png"
                alt=""
              />
            </template>
          </div>
        </div>
      </draggable>
      <div class="sp-line">
        <div class="title">
          <span>本回合SP消耗：</span>
          <span>{{ usedSp }}</span
          >/<span class="total-sp" data-map-key="totalSp">{{ totalSp }}</span>
        </div>
        <div class="sp-container">
          <div v-for="item in spCalcData" :key="item.index" class="star-item">
            <img v-if="item.type === 'error'" src="@/assets/zs_imgs/battle/error_star.png" alt="" />
            <img v-else-if="item.type === 'used'" src="@/assets/zs_imgs/battle/used_star.png" alt="" />
            <img v-else-if="item.type === 'round'" src="@/assets/zs_imgs/battle/round_star.png" alt="" />
            <img v-else src="@/assets/zs_imgs/battle/default_star.png" alt="" />

            <span v-if="isEdit">{{ item.index }}</span>
          </div>
        </div>
      </div>
    </template>
    <div v-if="!hasCurrentBattleData" class="empty-battle">
      <span class="text">该服装不适合{{ labelMap[currentIndex] }}</span>
    </div>
    <div class="des" @wheel.stop>
      <el-input
        v-if="isEdit"
        type="textarea"
        :autosize="true"
        placeholder="批注内容"
        v-model="roundInfos[currentIndex].des"
      ></el-input>
      <pre v-if="!isEdit && roundInfos[currentIndex].des.replace(/\s/g, '')">{{ roundInfos[currentIndex].des }}</pre>
    </div>

    <EditRole
      ref="editRoleRef"
      :roleList="roleList"
      :initRoleData="currentEditRoleData"
      @updateRole="handleUpdateRole"
      :choosedRoleCount="choosedRoleCount"
    />
    <EditTeam
      ref="editTemRef"
      :battleType="1"
      :current="roundInfos[currentIndex]"
      :roleList="roleList"
      @updateTeam="handleUpdateTeam"
    />
    <ViewRole ref="roleInfoRef" :currentShowRoleData="currentShowRoleData" />
  </div>
</template>
<script>
import draggable from "vuedraggable";
import EditTeam from "./editTeam.vue";
import Round from "./round.vue";
import EditRole from "./editRole.vue";
import ViewRole from "./viewRole.vue";
import { apiGetBattleRoleList } from "@/api/wiki-zsca";
import { mapGetters } from "vuex";
import { createUniqueKey, v4 } from "@/plugins/util";

export default {
  components: {
    draggable,
    EditTeam,
    Round,
    EditRole,
    ViewRole
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    currentShowData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      actionObj: {
        skills: "技能",
        damage: "攻击",
        repel: "击退",
        dead: "无法战斗"
      },
      strengthArr: ["+1", "+2", "+3", "+4", "+5", "满破满潜力"],
      roleList: [], // 角色列表
      // 要交换的目标元素下标
      destIndex: -1,
      // 要交换的起始元素下标
      srcIndex: -1,
      currentIndex: 0,
      roundInfos: [],
      // 当前编辑的角色数据
      currentEditRoleIndex: -1,
      currentEditRoleData: {},
      totalSp: 0,
      currentShowRoleData: {},
      labelMap: {
        0: "推图",
        1: "PVP",
        2: "BOSS"
      }
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    // 本回合消耗的sp
    usedSp() {
      let sp = 0;
      const battleData = this.roundInfos[this.currentIndex].battleData || [];
      battleData.forEach(item => {
        if (item.sp) {
          sp += Number(item.sp);
        }
      });
      return sp;
    },
    // 本回合选了的角色数量
    choosedRoleCount() {
      return this.roundInfos[this.currentIndex].battleData.filter(item => item.type !== 0).length;
    },
    spCalcData() {
      // 1 填充20个空数据的数组，
      let result = [];
      const len = 20;
      for (let i = 0; i < len; i++) {
        result.push({
          index: i + 1
        });
      }
      if (this.usedSp > this.totalSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "error"
            };
          }
          return item;
        });
      } else if (this.usedSp === this.totalSp) {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          }
          return item;
        });
      } else {
        result = result.map((item, index) => {
          if (index < this.usedSp) {
            return {
              ...item,
              type: "used"
            };
          } else if (index < this.totalSp) {
            return {
              ...item,
              type: "round"
            };
          }
          return item;
        });
      }
      return result;
    },
    hasCurrentBattleData() {
      const result = this.roundInfos[this.currentIndex] && this.roundInfos[this.currentIndex].battleData;
      if (!result || !result.length) return false;
      return result.some(battle => battle.type !== 0);
    }
  },
  watch: {
    currentShowData: {
      handler(newVal) {
        if (newVal && newVal.battleData) {
          this.roundInfos = JSON.parse(JSON.stringify(newVal.battleData));
          // 找到当前回合数据不为空的index
          const findIndex = this.roundInfos.findIndex(
            item => item.battleData && item.battleData.some(item => item.type !== 0)
          );

          if (findIndex !== -1) {
            this.currentIndex = findIndex;
          } else {
            this.currentIndex = 0;
          }
          // this.currentIndex = 0;
        } else {
          this.setInitRoundData();
        }
        if (newVal.totalSp) {
          this.totalSp = newVal.totalSp;
        } else {
          this.totalSp = 0;
        }
      },
      immediate: true
    }
  },
  mounted() {
    // this.setInitRoundData();
    this.getRoleList();
  },
  methods: {
    // 获取角色列表
    getRoleList() {
      apiGetBattleRoleList().then(res => {
        if (res.code === 0) {
          if (res.data && (res.data.role || res.data.pet)) {
            const result = [];
            res.data.role &&
              res.data.role.forEach(item => {
                if (item.children) {
                  item.children.forEach(child => {
                    result.push({
                      ...child,
                      type: "role"
                    });
                  });
                }
              });
            res.data.pet &&
              res.data.pet.forEach(item => {
                result.push({
                  ...item,
                  id: item.name,
                  star: "pet",
                  type: "pet"
                });
              });
            this.roleList = result;
          }
        }
      });
    },
    setInitRoundData() {
      for (let i = 0; i < 3; i++) {
        const obj = {
          des: ``,
          battleData: [],
          key: createUniqueKey()
        };
        let teamLength = 12;
        for (let i = 0; i < teamLength; i++) {
          obj.battleData.push({
            type: 0
          });
        }
        this.$set(this.roundInfos, i, obj);
      }
    },
    handleOurMove(e) {
      this.destIndex = e.draggedContext.futureIndex;
      return false;
    },
    handleOurStart(e) {
      this.srcIndex = e.oldIndex;
    },
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    handleOurEnd(e) {
      if (this.destIndex === this.srcIndex || this.destIndex === -1) {
        return;
      }
      // 开始拖拽的元素和目标元素交换位置
      const lastItem = this.roundInfos[this.currentIndex].battleData[this.destIndex];
      const firstItem = this.roundInfos[this.currentIndex].battleData[this.srcIndex];
      this.roundInfos[this.currentIndex].battleData.splice(this.srcIndex, 1, lastItem);
      this.roundInfos[this.currentIndex].battleData.splice(this.destIndex, 1, firstItem);

      this.destIndex = -1;
    },
    // 编辑队伍
    handleEditTeam() {
      if (!this.isEdit) return;
      this.$refs.editTemRef.visible = true;
    },
    // 编辑角色
    handleEditRole(data, index) {
      if (!this.isEdit && data.type !== 0) {
        this.currentShowRoleData = data;
        this.$nextTick(() => {
          this.$refs.roleInfoRef.visible = true;
        });
        return;
      }
      if (!this.isEdit || data.type === 0) return;
      this.currentEditRoleIndex = index;
      this.currentEditRoleData = JSON.parse(JSON.stringify(data));
      if (!this.currentEditRoleData.v4) {
        this.currentEditRoleData.v4 = v4();
      }
      this.$nextTick(() => {
        this.$refs.editRoleRef.visible = true;
      });
    },
    // 更新角色
    handleUpdateRole(data) {
      const copyData = JSON.parse(JSON.stringify(data));
      const findPositionIndex = this.roundInfos[this.currentIndex].battleData.findIndex(
        i => i.uniqueKey === data.uniqueKey
      );
      this.$set(this.roundInfos[this.currentIndex].battleData, findPositionIndex, copyData);
    },
    handleChangeIndex(index) {
      this.currentIndex = index;
    },
    // 更新队伍
    handleUpdateTeam(data) {
      const positionData = this.roundInfos[this.currentIndex].battleData;
      data.forEach(item => {
        const findIndex = positionData.findIndex(i => i.uniqueKey === item.uniqueKey);
        if (findIndex === -1) {
          const firstEmptyIndex = positionData.findIndex(i => i.type === 0);
          if (firstEmptyIndex !== -1) {
            this.$set(positionData, firstEmptyIndex, item);
          }
        }
      });
      // 过滤掉position中已经不在sort中的数据
      positionData.forEach((item, index) => {
        if (item.type !== 0 && !data.find(i => i.uniqueKey === item.uniqueKey)) {
          this.$set(positionData, index, {
            type: 0
          });
        }
      });
      this.$set(this.roundInfos[this.currentIndex], "battleData", positionData);
      console.log("更新后的队伍数据：", this.roundInfos[this.currentIndex].battleData);
    },
    // 获取强化图标
    getStrenthUrl(name) {
      if (name === "满破满潜力") {
        return require(`@/assets/zs_imgs/battle/strenth_full.webp`);
      }
      return require(`@/assets/zs_imgs/battle/strenth${name}.webp`);
    },
    // 获取角标图片
    getCornerUrl(item) {
      const star = parseInt(item.star);
      let potentialLength = item.currentPotential ? item.currentPotential.length : 0;
      if (potentialLength > 3) {
        potentialLength = 3;
      }
      if (star < 5) {
        if (potentialLength > 1) {
          potentialLength = 1;
        }
        return require(`@/assets/zs_imgs/battle/potential_${potentialLength}_star_34.png`);
      } else {
        return require(`@/assets/zs_imgs/battle/potential_${potentialLength}_star_5.png`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/views/wiki/battle/components/common.less";

.battle-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  padding: 28px;
  box-sizing: border-box;
  background: rgba(63, 69, 83, 0.25);
  border-radius: 16px;
  overflow: hidden;
  .round {
    flex: 0 0 auto;
    margin-bottom: 22px;
  }
  .drag-list {
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    // padding-bottom: 15px;
    margin-bottom: 15px;
    gap: 18px 16px;
    .drag-bg {
      width: 108px;
      height: 108px;
      position: relative;
      box-sizing: border-box;
      background-color: #151519;
      // 禁止选择
      user-select: none;
      transition: all ease;
      .drag-item {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        // padding: 5px;
        box-sizing: border-box;
        cursor: pointer;
        .default-icon {
          width: 50px;
          height: 50px;
        }
        .role-bg {
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;
          .item-infos {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            .index {
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              left: 0;
              top: 0;
              width: 22px;
              height: 26px;
              color: #fff;
              font-size: 14px;
              font-weight: 500;
              background: url("~@/assets/zs_imgs/battle/index_tag_bg.png") no-repeat;
              background-size: 100% 100%;
            }
            .strenth-icon {
              position: absolute;
              right: 0;
              top: 0;
              width: 32px;
              height: 24px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .skill-icon {
              display: flex;
              position: absolute;
              // top: 35px;
              bottom: 26px;
              left: 2px;
              width: 24px;
              height: 24px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .corner-icon {
              display: flex;
              position: absolute;
              // top: 35px;
              bottom: 26px;
              right: 2px;
              width: 26px;
              height: 26px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }
            .bottom-info {
              position: absolute;
              bottom: 0;
              left: 0;
              display: flex;
              align-items: center;
              width: 100%;
              height: 25px;
              padding: 3px 3px;
              box-sizing: border-box;
              background-color: rgba(34, 24, 21, 0.69);

              .label {
                // display: flex;
                flex: 1;
                color: #fff;
                font-size: 12px;
                text-align: center;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        .role-img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 150%;
          height: 150%;
          object-fit: cover;
        }
        .border-line {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .sp-line {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 13px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
    .total-sp {
      min-width: 20px;
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }
    .sp-container {
      display: flex;
      align-items: center;
      .star-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 9px;
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 10px;
          height: 10px;
          margin-bottom: 2px;
        }
        span {
          color: #828ea0;
          font-size: 10px;
        }
      }
    }
  }
  .empty-battle {
    position: relative;
    height: 360px;
    margin-bottom: 15px;
    background: url("~@/assets/zs_imgs/zbtj/empty-battle-bg1.png") center / contain no-repeat,
      url("~@/assets/zs_imgs/zbtj/empty-battle-bg2.png") center / contain no-repeat;
    .text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      font-size: 16px;
      white-space: nowrap;
    }
  }
  .des {
    flex: 1;
    overflow: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    /deep/.el-textarea__inner {
      background: #1c232e;
      border: none;
      border-radius: 4px;
      color: #fff;
      &::placeholder {
        color: #5a606b;
      }
    }
    pre {
      margin: 0;
      padding: 0;
      color: #bbbbbb;
      font-size: 18px;
      // font-weight: 500;
      line-height: 24px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}

.battle-container.light {
  background: rgba(226, 231, 230, 0.73);
  .drag-list {
    .drag-bg {
      background-color: rgba(255, 255, 255, 0.66);
      background-image: url("~@/assets/zs_imgs/light-drag-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .sp-line {
    .title {
      color: #333;
    }
    .sp-container {
      .star-item {
        span {
          color: #484848;
        }
      }
    }
  }
  .des pre {
    color: #484848;
  }
}
</style>
